import $ from "jquery";
import { __ } from "../utils/i18n.js";
import { getStaticOptions } from "../utils/options.js";
import { request } from "../utils/request.js";
import { locationRestCrossDismissDelete } from "../wp-api/cross-dismiss.delete.js";
const DATA_MEMORIZE_CREATED = "crossSellingPointer";
class CrossSellingPointer {
    /* istanbul ignore next */ constructor($handler, slug, action, position){
        this.slug = slug;
        this.action = action;
        this.position = position;
        this.$handler = $handler;
        this.init();
    }
    static waitForVisibleElement(selector, slug, action, position) {
        if (!this.isActionAvailable(slug, action)) {
            return false;
        }
        const $details = $(selector);
        if ($details.length && !$details.data(DATA_MEMORIZE_CREATED)) {
            $details.data(DATA_MEMORIZE_CREATED, true);
            new CrossSellingPointer($details, slug, action, position);
        }
        return $details.length > 0;
    }
    static isActionAvailable(slug, action) {
        var _getStaticOptions_cross_slug, _getStaticOptions_cross;
        return !!((_getStaticOptions_cross = getStaticOptions().cross) == null ? void 0 : (_getStaticOptions_cross_slug = _getStaticOptions_cross[slug]) == null ? void 0 : _getStaticOptions_cross_slug[action]);
    }
    close(e, redirect) {
        e.preventDefault();
        const force = this.$handler.pointer("widget").find('input[type="checkbox"]').is(":checked");
        this.$handler.pointer("close");
        this.$handler.pointer("destroy");
        // force means in this context, that we clicked "Rate now"
        if (redirect) {
            const { link } = this.getAction();
            window.open(link, "_blank");
        }
        request({
            location: locationRestCrossDismissDelete,
            params: {
                slug: this.slug,
                action: this.action,
                force
            }
        });
    }
    buttons() {
        const close = $(`<a class="button" href="#">${__("Not now")}</a>`).click((e)=>{
            this.close(e, false);
        });
        const rateNow = $(`<a class="button button-primary" href="#">${__("Learn more!")}</a>`).click((e)=>{
            this.close(e, true);
        });
        return $('<div class="real-utils-pointer-buttons" />').append(rateNow, close);
    }
    getAction() {
        var _getStaticOptions_cross;
        return (_getStaticOptions_cross = getStaticOptions().cross) == null ? void 0 : _getStaticOptions_cross[this.slug][this.action];
    }
    init() {
        const { position } = this;
        const { title, description, image } = this.getAction();
        const neverAgainCheckbox = `<label><input type="checkbox" /> ${__("Never show this popup again")}</label>`;
        this.$handler.pointer({
            pointerClass: `wp-pointer real-utils-cross-pointer`,
            content: `<h3>${title}</h3><p><img src="${image}" />${description}${neverAgainCheckbox}</p>`,
            buttons: this.buttons.bind(this),
            position
        }).pointer("open")// Reposition when image is loaded completely
        .pointer("widget").find("img").get(0).onload = ()=>this.$handler.pointer("reposition");
    }
}
export { CrossSellingPointer };
